import React, { useState } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { translations } from './utils/translations';

function App() {
  const [currentLang, setCurrentLang] = useState('fr');
  const t = translations[currentLang];

  return (
    <div className="App">
      <Toaster position="top-right" />
      <Header 
        currentLang={currentLang} 
        setCurrentLang={setCurrentLang}
        translations={t}
      />
      <Hero translations={t} />
      <Services translations={t} />
      <About translations={t} />
      <Contact translations={t} />
      <Footer translations={t} />
    </div>
  );
}

export default App;
